import * as React from 'react'
import { useParams } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { PublicFilesFolderPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import DocumentURLContext from 'modules/documents/components/Documents/List/DocumentURLContext'
import FolderContent from 'modules/documents/components/FolderContent'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { SPACES } from 'modules/documents/lib/constants'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const PublicCompanyFolderDocumentsPage = () => {
  const { navigation } = useNavigation()
  const { folderId } = useParams()
  const parsedFolderId = String(folderId)

  const { loading, data, error } = useQuery(PublicFilesFolderPageDocument, {
    variables: {
      folderId: parsedFolderId,
      space: SPACES.COMPANY_PUBLIC,
    },
  })

  const [selectedFolder, setSelectedFolder] = React.useState<Folder>()

  const canEditPublicDocuments =
    (data?.documents?._policies.companyEditPublicDocuments.can ||
      data?.documents?._policies.companyUseCompanyDocuments.can) ??
    false

  const canSeePublicDocuments = data?.documents?._policies.companySeePublicDocuments.can

  const folder = data?.documents?.foldersConnection?.edges[0]?.node

  const documentRoutesContext = {
    show: (id: string | number) =>
      navigation.files.companyFiles.folderId.documentId.fullPath({
        folderId: String(folderId),
        document_id: id,
      }),
  }

  if (loading)
    return (
      <Box padding="s40" width="full" alignItems="center" flexGrow>
        <Spinner />
      </Box>
    )

  return (
    <DocumentURLContext.Provider value={documentRoutesContext}>
      <ResponsivePage.Body
        showHeader={false}
        loading={loading}
        error={error}
        authorized={canSeePublicDocuments}
      >
        {folder && (
          <FolderContent
            canUploadDocument={canEditPublicDocuments}
            folder={folder}
            selectedFolder={selectedFolder}
            setSelectedFolder={setSelectedFolder}
            parentRoute={navigation.files.companyFiles.folderId.fullPath({
              folderId: parsedFolderId,
            })}
          />
        )}
      </ResponsivePage.Body>
    </DocumentURLContext.Provider>
  )
}

export default PublicCompanyFolderDocumentsPage
